var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCardIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0112 6.77393C6.88228 6.77393 3.53516 10.1211 3.53516 14.2499V32.8389C3.53516 34.6875 5.47707 35.8926 7.13346 35.0719L13.169 32.0817C14.2007 31.5705 15.3365 31.3046 16.4879 31.3046H29.891C34.0199 31.3046 37.367 27.9575 37.367 23.8286V14.2499C37.367 10.121 34.0199 6.77393 29.891 6.77393H11.0112Z",
    fill: "url(#paint0_linear_1455_20527)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8398 19.04C12.8398 18.1933 13.5263 17.5068 14.373 17.5068C15.2198 17.5068 15.9062 18.1933 15.9062 19.04C15.9062 19.8867 15.2198 20.5732 14.373 20.5732C13.5263 20.5732 12.8398 19.8867 12.8398 19.04Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9707 19.04C18.9707 18.1933 19.6571 17.5068 20.5039 17.5068C21.3506 17.5068 22.037 18.1933 22.037 19.04C22.037 19.8867 21.3506 20.5732 20.5039 20.5732C19.6571 20.5732 18.9707 19.8867 18.9707 19.04Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1094 19.0405C25.1094 18.1937 25.7958 17.5073 26.6425 17.5073C27.4893 17.5073 28.1757 18.1937 28.1757 19.0405C28.1757 19.8872 27.4893 20.5737 26.6425 20.5737C25.7958 20.5737 25.1094 19.8872 25.1094 19.0405Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7536 37.8453C32.7536 37.8453 40.1673 34.1385 40.1673 28.5782V22.0912L32.7536 19.311L25.3398 22.0912V28.5782C25.3398 34.1385 32.7536 37.8453 32.7536 37.8453Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7536 37.8453C32.7536 37.8453 40.1673 34.1385 40.1673 28.5782V22.0912L32.7536 19.311L25.3398 22.0912V28.5782C25.3398 34.1385 32.7536 37.8453 32.7536 37.8453Z",
    fill: "url(#paint1_linear_1455_20527)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6504 27.2152L31.9211 30.4859L37.3724 25.0347",
    stroke: "white",
    strokeWidth: 1.63538,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_20527",
    x1: 7.89616,
    y1: 7.63055,
    x2: 35.3082,
    y2: 30.6816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#FB05E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#6F00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1455_20527",
    x1: 32.7536,
    y1: 19.311,
    x2: 32.7536,
    y2: 37.8453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCardIcon8);
export default __webpack_public_path__ + "static/media/message_card_icon8.299068a5a0ffa150377c595cd08e5a64.svg";
export { ForwardRef as ReactComponent };